// Copyright 2018 Sorama B.V.

import { GenericMeasurement, Point3D } from "datatypes/SoramaWebApi";
import { ComputationMode } from "modules/workflows/Analysis/Spectrum/SpectrumModuleModes";
import { UnitSpectrum } from "units/UnitSpectrum";
import { WeightedSpectrum } from "units/WeightedSpectrum";

export class UnitSpectrumWithMeasurement extends UnitSpectrum {
    public measurement: GenericMeasurement;
    public usedComputationMode: ComputationMode;
    public selectedMic: Point3D;
}

export class WeightedSpectrumWithMeasurement extends WeightedSpectrum {
    public measurement: GenericMeasurement;
    public usedComputationMode: ComputationMode;
    public selectedMic: Point3D;
}
